import ButtonText from '../components/ButtonText';
import translate from '../components/LanguageManager';
import BaseScene from './BaseScene';
import { Capacitor } from '@capacitor/core';
import { App } from '@capacitor/app';

export default class MainMenu extends BaseScene {

    private userName = '';

    constructor() {
        super({key: 'MainMenu'});   
    }

    public preload(): void {
        // eslint-disable-next-line @typescript-eslint/no-empty-function
    }

    public init(): void {
        super.init();
        this.userName = this.getBootloaderScene().AppData.user.name; 
    }
    
    public create(): void {
        super.create();

        // Music
        if(this.bootloaderScene) {
            this.bootloaderScene.soundManager.playMainMenuMusic();  
        }

        // BG
        const bg = this.add.image(this.width / 2, this.height / 2, 'main_menu_bg').setOrigin(.5);
        this.forceSpriteNotScaleY(bg);
        
        // Logo
        this.add.image(this.width / 2, 40, 'main_menu_logo').setOrigin(.5, 0);

        // Main Menu
        const panel = this.add.image(0, 0, 'game_panel_main_menu').setOrigin(.5);
        const playButton = new ButtonText(this, 0, -130, translate.key('Play'), () => this.playGame());
        const settingsButton = new ButtonText(this, 0, -70, translate.key('Settings'), () => this.goToSettings());
        const scoreButton = new ButtonText(this, 0, -10, translate.key('Score'), () => this.goToScore());
        const aboutButton = new ButtonText(this, 0, 50, translate.key('About'), () => this.goToAbout());
        const exitButton = new ButtonText(this, 0,110, translate.key('Exit'), () => this.exitGame());
        const panelContainer = this.add.container(this.width / 2, 720).add([panel, playButton, aboutButton, settingsButton, scoreButton, exitButton]);
        this.forceSpriteBottomPosition(panelContainer, 40);
    }

    private exitGame(): void {
        this.getBootloaderScene().AppData.saveRemote('levels')
            .catch(() => {
            // swallow save errors - proceed with exit flow regardless
            })
            .finally(() => {
                if (Capacitor.getPlatform() === 'ios' || Capacitor.getPlatform() === 'android') {
                    App.exitApp();
                }

                if (Capacitor.getPlatform() === 'web') {
                    window.location.reload();  
                }
            });
    }

    private playGame(): void {
        if(this.userName === '') {
            this.scene.pause('MainMenu');
            this.scene.launch('SettingName');
            this.scene.bringToTop('SettingName');
            return;
        }

        if(this.bootloaderScene) {
            this.bootloaderScene.launchScene('LevelSelector');
        }
    }

    private goToAbout(): void {
        this.scene.pause('MainMenu');
        this.scene.launch('About');
        this.scene.bringToTop('About');
    }

    private goToSettings(): void {
        this.scene.pause('MainMenu');
        this.scene.launch('Settings');
        this.scene.bringToTop('Settings');
    }

    private goToScore(): void {
        this.scene.pause('MainMenu');
        this.scene.launch('Score');
        this.scene.bringToTop('Score');
    }
}
